import PropTypes from 'prop-types';

import AssetRoundSelector from '../AssetRoundSelector/AssetRoundSelector';
import NavigationBreadcrumbsContainer from '../../../containers/NavigationBreadcrumbsContainer/NavigationBreadcrumbsContainer';

import Asset from '../../../entities/asset';
import AssetRound from '../../../entities/assetRound';

import './AssetDetailsHeader.scss';

const AssetDetailsHeader = ( {
	asset, rounds, selectedRound, onSelectedRoundChange,
	showRounds, projectID, userIsViewingPreviousRound
} ) => (
	asset && (
		<div className="AssetDetailsHeader">
			<NavigationBreadcrumbsContainer
				projectID={projectID}
				folderID={asset.folderID}
				assetID={asset.id}
			/>
			{showRounds && selectedRound
					&& (
						<AssetRoundSelector
							selected={selectedRound}
							rounds={rounds}
							onChange={onSelectedRoundChange}
							disabled={userIsViewingPreviousRound}
						/>
					)}
		</div>
	)
);

AssetDetailsHeader.propTypes = {
	asset: PropTypes.instanceOf( Asset ),
	rounds: PropTypes.arrayOf( PropTypes.instanceOf( AssetRound ) ),
	selectedRound: PropTypes.instanceOf( AssetRound ),
	onSelectedRoundChange: PropTypes.func,
	showRounds: PropTypes.bool,
	projectID: PropTypes.number,
	userIsViewingPreviousRound: PropTypes.bool
};

AssetDetailsHeader.defaultProps = {
	asset: undefined,
	rounds: [],
	selectedRound: undefined,
	onSelectedRoundChange: undefined,
	showRounds: true,
	projectID: undefined,
	userIsViewingPreviousRound: false
};

export default AssetDetailsHeader;
